(function () {
    'use strict';

    angular
    .module('szallodak-child-ages', ['ui.checkbox']);
})();
